import { VISIT_ACTUAL_UPDATE_VISIT_TIME, VISIT_ACTUAL_ADD_ACTIVITY_TIME } from '../../constants/types';

function updateVisitTime(time) {
  return {
    type: VISIT_ACTUAL_UPDATE_VISIT_TIME,
    time,
  };
}

function addActivityTime(time) {
  return {
    type: VISIT_ACTUAL_ADD_ACTIVITY_TIME,
    time,
  };
}

export { updateVisitTime, addActivityTime };
